import React from "react";
import { Search } from "lucide-react";
import ReportSelect from "./ReportSelect";

const input = "h-10 rounded-xl border border-[#f2c6cc] bg-white px-3 text-xs font-medium text-slate-700 outline-none transition focus:border-[#d86a78] focus:ring-2 focus:ring-[#f7d8dc]";
const label = "mb-1.5 block text-[10px] font-semibold text-[#d86a78]";

function Field({ title, children }) {
  return <label className="block"><span className={label}>{title}</span>{children}</label>;
}

export default function ReportFilters({ filters, setFilters, dropdowns = {} }) {
  const patch = (k, v) => setFilters((p) => ({ ...p, [k]: v, page: 1 }));

  return (
    <div className="rounded-[18px] border border-[#f4cdd2] bg-white p-4 shadow-sm">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3 xl:grid-cols-7">
        <Field title="Period">
          <ReportSelect value={filters.period} onChange={(value) => patch("period", value)} options={[{ value: "today", label: "Today" }, { value: "yesterday", label: "Yesterday" }, { value: "last7", label: "Last 7 Days" }, { value: "last30", label: "Last 30 Days" }, { value: "week", label: "This Week" }, { value: "month", label: "This Month" }, { value: "lastMonth", label: "Last Month" }, { value: "year", label: "This Year" }, { value: "all", label: "All Time" }, { value: "custom", label: "Custom" }]} />
        </Field>
        <Field title="Start date"><input className={`${input} w-full`} type="date" value={filters.startDate || ""} onChange={(e) => patch("startDate", e.target.value)} /></Field>
        <Field title="End date"><input className={`${input} w-full`} type="date" value={filters.endDate || ""} onChange={(e) => patch("endDate", e.target.value)} /></Field>
        <Field title="Warehouse">
          <ReportSelect value={filters.warehouseId || ""} onChange={(value) => patch("warehouseId", value)} options={[{ value: "", label: "All Warehouses" }, ...(dropdowns.warehouses || []).map((warehouse) => ({ value: warehouse.id, label: warehouse.name || warehouse.code }))]} />
        </Field>
        <Field title="City"><ReportSelect value={filters.city || ""} onChange={(value) => patch("city", value)} options={[{ value: "", label: "All Cities" }, ...(dropdowns.cities || []).map((city) => ({ value: city, label: city }))]} /></Field>
        <Field title="State"><ReportSelect value={filters.state || ""} onChange={(value) => patch("state", value)} options={[{ value: "", label: "All States" }, ...(dropdowns.states || []).map((item) => ({ value: item, label: item }))]} /></Field>
        <Field title="Search">
          <div className="relative">
            <Search size={14} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[#d86a78]" />
            <input className={`${input} w-full pl-9`} placeholder="Name / phone / sku" value={filters.q || ""} onChange={(e) => patch("q", e.target.value)} />
          </div>
        </Field>
      </div>
    </div>
  );
}
